import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { API_BASE } from "../auth/api";

export default function Contacts() {
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [q, setQ] = useState("");

  // modal edición
  const [editOpen, setEditOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [saving, setSaving] = useState(false);

  // modal creación
  const [createOpen, setCreateOpen] = useState(false);
  const [creating, setCreating] = useState({
    name: "",
    phone: "",
    email: "",
    notes: "",
    tags: "",
    avatar_path: "",
    contract_number: ""   // ✅ NUEVO
  });
  const [page, setPage] = useState(1);
  const limit = 10;
  const [total, setTotal] = useState(0);

  const [historyOpen, setHistoryOpen] = useState(false);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [history, setHistory] = useState({ contact: null, threads: [], leads: [], messages: [] });
  const [historyNext, setHistoryNext] = useState(null);
  const [loadingMore, setLoadingMore] = useState(false);
  async function openHistory(c) {
    setHistoryOpen(true);
    setHistoryLoading(true);
    try {
      const { data } = await api.get(`/contacts/${c.id}/messages`, { params: { limit: 200 } });


      setHistory({
        contact: data?.contact || null,
        leads: data?.leads || [],
        threads: [], // si ya no lo usas
        messages: data?.messages || []
      });
      setHistoryNext(data?.next_before_id || null);
    } catch (e) {
      console.error("openHistory", e);
      setHistory({ contact: null, leads: [], threads: [], messages: [] });
      setHistoryNext(null);
    } finally {
      setHistoryLoading(false);
    }
  }

  function formatDateSmart(ts) {
    if (!ts) return "—";

    // si viene como número (epoch)
    if (typeof ts === "number") {
      const d = new Date(ts);
      return new Intl.DateTimeFormat("es-EC", {
        dateStyle: "medium",
        timeStyle: "short",
        hour12: true,
        timeZone: "America/Guayaquil",
      }).format(d);
    }

    const s = String(ts);

    // Detecta zona horaria en el string (Z o +hh:mm / -hh:mm)
    const hasTZ = /Z$|[+-]\d{2}:\d{2}$/.test(s);

    // ✅ Si NO hay timezone, normalmente ya viene “bien”: no lo toques
    if (!hasTZ) return s;

    // ✅ Si hay timezone (ej: ...Z), convertir a Guayaquil
    const d = new Date(s);
    if (Number.isNaN(d.getTime())) return s;

    return new Intl.DateTimeFormat("es-EC", {
      dateStyle: "medium",
      timeStyle: "short",
      hour12: true,
      timeZone: "America/Guayaquil",
    }).format(d);
  }

  async function loadMoreHistory() {
    if (!history?.contact?.phone || !historyNext || loadingMore) return;
    setLoadingMore(true);
    try {
      const { data } = await api.get(`/contacts/${encodeURIComponent(history.contact.phone)}/timeline`, {
        params: { limit: 300, before_id: historyNext }
      });

      const newMsgs = data?.messages || [];
      setHistory((prev) => ({
        ...prev,
        // leads no cambian, pero por si acaso:
        leads: data?.leads?.length ? data.leads : prev.leads,
        messages: [...(prev.messages || []), ...newMsgs]
      }));
      setHistoryNext(data?.next_before_id || null);
    } catch (e) {
      console.error("loadMoreHistory", e);
    } finally {
      setLoadingMore(false);
    }
  }
  // -------------------------
  // Fetch contactos
  // -------------------------
  async function fetchContacts() {
    setLoading(true);
    try {
      const { data } = await api.get("/contacts", {
        params: {
          q: q || "",
          page,
          limit
        }
      });

      setRows(data?.rows || []);
      setTotal(data?.total || 0);
    } catch (e) {
      console.error("fetchContacts", e);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchContacts();
  }, [q, page]);

  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") {
        setEditOpen(false);
        setCreateOpen(false);
        setHistoryOpen(false);
      }
    }

    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  // -------------------------
  // Abrir chat
  // -------------------------
  function openChat(c) {
    navigate(`/chat?phone=${encodeURIComponent(c.phone)}`);
  }

  // -------------------------
  // Editar contacto
  // -------------------------
  function startEdit(row) {
    setEditing({ ...row });
    setEditOpen(true);
  }
  async function saveCreate() {
    if (!creating.phone) {
      alert("El teléfono es obligatorio");
      return;
    }

    try {
      //await api.post("/newcontacts", creating);

      await api.post("/contacts", {
        ...creating,
        phone: creating.phone.replace(/\D/g, "")
      });

      setCreateOpen(false);
      setCreating({
        name: "",
        phone: "",
        email: "",
        notes: "",
        tags: "",
        avatar_path: "",
        contract_number: ""   // ✅
      });
      fetchContacts();
    } catch (e) {
      alert(e?.response?.data?.error || "No se pudo crear");
    }
  }
  async function saveEdit() {
    if (!editing?.id) return;
    setSaving(true);
    try {
      await api.patch(`/contacts/${editing.id}`, {
        name: editing.name,
        email: editing.email,
        notes: editing.notes,
        tags: editing.tags,
        avatar_path: editing.avatar_path,
        contract_number: editing.contract_number  // ✅ NUEVO
      });
      setEditOpen(false);
      setEditing(null);
      fetchContacts();
    } catch (e) {
      alert(e?.response?.data?.error || "No se pudo guardar");
    } finally {
      setSaving(false);
    }
  }

  // -------------------------
  // Eliminar contacto
  // -------------------------
  async function removeContact(id) {
    if (!window.confirm("¿Eliminar este contacto?")) return;
    try {
      await api.delete(`/contacts/${id}`);
      fetchContacts();
    } catch (e) {
      alert("No se pudo eliminar");
    }
  }

  // -------------------------
  // Marcar visto por PHONE
  // -------------------------
  async function markSeenByPhone(phone) {
    try {
      await api.post(`/contacts/by-phone/${encodeURIComponent(phone)}/seen`);
      fetchContacts();
    } catch { }
  }

  return (
    <div className="contacts-root">
      <style>{css}</style>

      <div className="topbar">
        <div className="search">
          <input
            className="input"
            placeholder="Buscar por contrato, nombre, teléfono, email o notas…"
            value={q}
            onChange={(e) => {
              setQ(e.target.value);
              setPage(1);
            }}
          />
        </div>

        <button className="btn-new" onClick={() => setCreateOpen(true)}>
          + Nuevo contacto
        </button>
      </div>
      <div className="table-card">
        <div className="table-wrap">
          {loading ? (
            <div className="empty">Cargando contactos…</div>
          ) : rows.length ? (
            <>
              <table>
                <thead>
                  <tr>
                    <th>Avatar</th>
                    <th>Nombre</th>
                    <th>Teléfono</th>
                    <th>Email</th>
                    <th>Tags</th>
                    <th>Últ. visto</th>
                    <th>Contrato</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((c) => (
                    <tr key={c.id}>
                      <td>
                        {c.avatar_path ? (
                          <img
                            src={`${API_BASE}${c.avatar_path.startsWith("/") ? "" : "/"}${c.avatar_path}`}
                            className="avatar"
                          />
                        ) : (
                          <div className="avatar ph">
                            {(c.name || c.phone || "?")[0]}
                          </div>
                        )}
                      </td>
                      <td>
                        <b>{c.name || "—"}</b>
                        {c.notes ? <div className="note">{c.notes}</div> : null}
                      </td>
                      <td>{c.phone}</td>
                      <td>{c.email || "—"}</td>
                      <td>{c.tags || "—"}</td>

                      <td>
                        {c.last_seen ? (
                          <>
                            {c.last_seen}
                            <button
                              className="mini"
                              onClick={() => markSeenByPhone(c.phone)}
                            >
                              Actualizar
                            </button>
                          </>
                        ) : "—"}
                      </td>
                      <td>{c.contract_number || "—"}</td>
                      <td className="actions">
                        <button onClick={() => openChat(c)}>Chat</button>
                        <button onClick={() => startEdit(c)}>Editar</button>
                        <button onClick={() => openHistory(c)}>Historial</button>
                        <button className="danger" onClick={() => removeContact(c.id)}>
                          Eliminar
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="pager-wrap">
                <div className="pager">
                  <button
                    disabled={page <= 1}
                    onClick={() => setPage(p => Math.max(1, p - 1))}
                  >
                    ◀ Anterior
                  </button>

                  <span>
                    Página {page} de {Math.max(1, Math.ceil(total / limit))}
                  </span>

                  <button
                    disabled={page >= Math.max(1, Math.ceil(total / limit))}
                    onClick={() => setPage(p => p + 1)}
                  >
                    Siguiente ▶
                  </button>
                </div>
              </div>
            </>

          ) : (
            <div className="empty">Sin contactos</div>
          )
          }
        </div >
      </div>
      {/* ---------------- MODAL EDICIÓN ---------------- */}
      {
        editOpen && editing && (
          <div className="modal-bg">
            <div className="modal">
              <div className="modal-title">Editar contacto</div>

              <input
                className="input"
                placeholder="Nombre"
                value={editing.name || ""}
                onChange={(e) =>
                  setEditing((v) => ({ ...v, name: e.target.value }))
                }
              />

              <input
                className="input"
                placeholder="Email"
                value={editing.email || ""}
                onChange={(e) =>
                  setEditing((v) => ({ ...v, email: e.target.value }))
                }
              />

              <input
                className="input"
                placeholder="Tags"
                value={editing.tags || ""}
                onChange={(e) =>
                  setEditing((v) => ({ ...v, tags: e.target.value }))
                }
              />

              <textarea
                className="input"
                placeholder="Notas"
                value={editing.notes || ""}
                onChange={(e) =>
                  setEditing((v) => ({ ...v, notes: e.target.value }))
                }
              />

              <input
                className="input"
                placeholder="Avatar URL"
                value={editing.avatar_path || ""}
                onChange={(e) =>
                  setEditing((v) => ({ ...v, avatar_path: e.target.value }))
                }
              />
              <input
                className="input"
                placeholder="Número de contrato"
                value={editing.contract_number || ""}
                onChange={(e) =>
                  setEditing((v) => ({ ...v, contract_number: e.target.value }))
                }
              />

              <div className="modal-actions">
                <button onClick={() => setEditOpen(false)}>Cancelar</button>
                <button onClick={saveEdit} disabled={saving}>
                  {saving ? "Guardando…" : "Guardar"}
                </button>
              </div>
            </div>
          </div>
        )
      }


      {historyOpen && (
        <div className="modal-bg">
          <div className="modal" style={{ width: 720, maxWidth: "92vw" }}>
            <div className="modal-title">
              Historial — {history.contact?.name || history.contact?.phone || "Contacto"}
            </div>

            {historyOpen && (
              <div className="modal-bg">
                <div className="modal" style={{ width: 720, maxWidth: "92vw" }}>
                  <div className="modal-title">
                    Historial — {history.contact?.name || history.contact?.phone || "Contacto"}
                  </div>

                  {historyLoading ? (
                    <div className="empty">Cargando…</div>
                  ) : (
                    <>
                      <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                        <span className="pill">
                          Contrato: <b>{history.contact?.contract_number || "—"}</b>
                        </span>
                        <span className="pill">
                          Mensajes: <b>{history.messages?.length || 0}</b>
                        </span>
                        <span className="pill">
                          Contacto ID: <b>{history.contact?.id || "—"}</b>
                        </span>
                      </div>

                      {/* ---------------- CONVERSACIÓN (cliente vs agente) ---------------- */}
                      <div style={{ borderTop: "1px solid #1e293b", marginTop: 12, paddingTop: 10 }}>
                        <b>Conversación</b>

                        <div style={{ marginTop: 10, display: "grid", gap: 10 }}>
                          {(history.messages || []).slice().reverse().map((m) => {
                            const isIn = m.direction === "in";
                            return (
                              <div
                                key={m.id}
                                style={{
                                  display: "flex",
                                  justifyContent: isIn ? "flex-start" : "flex-end",
                                }}
                              >
                                <div
                                  style={{
                                    maxWidth: "78%",
                                    padding: 10,
                                    borderRadius: 12,
                                    border: "1px solid #1e293b",
                                    background: isIn ? "#111827" : "#0b2a2a",
                                  }}
                                >
                                  <div style={{ fontSize: 12, color: "#94a3b8", marginBottom: 6 }}>
                                    <b style={{ color: "#e5e7eb" }}>{m.author_name}</b>
                                    {" · "}
                                    {formatDateSmart(m.created_at)}
                                    {" · "}
                                    {isIn ? "in" : "out"}
                                    {m.user_id ? ` · ${m.user_id}` : ""}
                                  </div>

                                  {m.text ? <div style={{ whiteSpace: "pre-wrap" }}>{m.text}</div> : null}

                                  {m.media_url ? (
                                    <div style={{ marginTop: 8 }}>
                                      <a href={m.media_url} target="_blank" rel="noreferrer">
                                        Ver archivo
                                      </a>
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                            );
                          })}

                          {!history.messages?.length ? (
                            <div className="empty" style={{ padding: 12 }}>
                              No hay mensajes para este contacto.
                            </div>
                          ) : null}
                        </div>

                        {/* Cargar más */}
                        <div style={{ display: "flex", justifyContent: "center", marginTop: 12 }}>
                          <button
                            onClick={loadMoreHistory}
                            disabled={!historyNext || loadingMore}
                            style={{
                              background: "#1f2937",
                              border: "1px solid #1e293b",
                              color: "white",
                              padding: "8px 12px",
                              borderRadius: 10,
                              cursor: historyNext ? "pointer" : "not-allowed",
                              opacity: historyNext ? 1 : 0.5,
                            }}
                          >
                            {loadingMore ? "Cargando..." : historyNext ? "Cargar más" : "No hay más"}
                          </button>
                        </div>
                      </div>
                    </>
                  )}

                  <div className="modal-actions">
                    <button onClick={() => setHistoryOpen(false)}>Cerrar</button>
                  </div>
                </div>
              </div>
            )}

            <div className="modal-actions">
              <button onClick={() => setHistoryOpen(false)}>Cerrar</button>
            </div>
          </div>
        </div>
      )}

      {
        createOpen && (
          <div className="modal-bg">
            <div className="modal">
              <div className="modal-title">Nuevo contacto</div>

              <input
                className="input"
                placeholder="Nombre"
                value={creating.name}
                onChange={(e) =>
                  setCreating((v) => ({ ...v, name: e.target.value }))
                }
              />

              <input
                className="input"
                placeholder="Teléfono *"
                value={creating.phone}
                onChange={(e) =>
                  setCreating((v) => ({ ...v, phone: e.target.value }))
                }
              />

              <input
                className="input"
                placeholder="Email"
                value={creating.email}
                onChange={(e) =>
                  setCreating((v) => ({ ...v, email: e.target.value }))
                }
              />

              <input
                className="input"
                placeholder="Tags"
                value={creating.tags}
                onChange={(e) =>
                  setCreating((v) => ({ ...v, tags: e.target.value }))
                }
              />

              <textarea
                className="input"
                placeholder="Notas"
                value={creating.notes}
                onChange={(e) =>
                  setCreating((v) => ({ ...v, notes: e.target.value }))
                }
              />

              <input
                className="input"
                placeholder="Avatar URL"
                value={creating.avatar_path}
                onChange={(e) =>
                  setCreating((v) => ({ ...v, avatar_path: e.target.value }))
                }
              />

              <input
                className="input"
                placeholder="Número de contrato"
                value={creating.contract_number || ""}
                onChange={(e) =>
                  setCreating((v) => ({ ...v, contract_number: e.target.value }))
                }
              />

              <div className="modal-actions">
                <button onClick={() => setCreateOpen(false)}>Cancelar</button>
                <button onClick={saveCreate}>Crear</button>
              </div>
            </div>
          </div>
        )
      }

    </div >
  );
}

/* ---------------- CSS ---------------- */
const css = `

/* ─────────────── CONTENEDOR REAL ─────────────── */

.table-card{
  background:#0f172a;
  border:1px solid #1e293b;
  border-radius:14px;
  overflow:hidden;
}

/* ─────────────── TABLA ─────────────── */

.table-wrap{
  overflow:auto;
}

table{
  width:100%;
  border-collapse:collapse;
  background:transparent;
}

th,td{
  padding:10px;
  border-bottom:1px solid #1e293b;
  text-align:left;
}

th{
  font-size:12px;
  color:#94a3b8;
}

/* ─────────────── PAGER SELLADO ─────────────── */

.pager-wrap{
  background:#020617;
  border-top:1px solid #1e293b;
  padding:12px;
  display:flex;
  justify-content:center;
}

.pager{
  display:flex;
  align-items:center;
  gap:10px;
}

.pager button{
  background:linear-gradient(180deg,#1e293b,#020617);
  border:1px solid #1e293b;
  color:#e5e7eb;
  padding:7px 16px;
  border-radius:10px;
  cursor:pointer;
  font-weight:600;
}

.pager button:hover:not(:disabled){
  background:#1e3a8a;
  border-color:#3b82f6;
}

.pager button:disabled{
  opacity:.35;
  cursor:not-allowed;
}

.pager span{
  background:#020617;
  border:1px solid #1e293b;
  padding:7px 14px;
  border-radius:10px;
  color:#94a3b8;
  font-size:13px;
  font-weight:600;
}

.btn-new{
  background:#22c55e;
  border:none;
  color:black;
  padding:10px 14px;
  border-radius:10px;
  font-weight:800;
  cursor:pointer;
}
.contacts-root{ height: auto; padding: 12px; background:#0b1220; color:#e5e7eb; }
.input{ background:#111827; border:1px solid #1e293b; border-radius:10px; padding:10px; color:white; }
.topbar{
  margin-bottom:12px;
  display:flex;
  gap:12px;
  align-items:center;
  justify-content:space-between;
}


.avatar{ width:36px; height:36px; border-radius:999px; object-fit:cover; }
.avatar.ph{ background:#3b82f6; display:grid; place-items:center; font-weight:900; }

.note{ font-size:11px; color:#94a3b8; }

.actions{ display:flex; gap:6px; }
.actions button{ background:#1f2937; border:none; color:white; padding:6px 10px; border-radius:8px; cursor:pointer; }
.actions .danger{ background:#7f1d1d; }

.mini{ margin-left:6px; font-size:10px; background:#1e3a8a; border:none; color:white; border-radius:6px; padding:2px 6px; }

.empty{ text-align:center; padding:30px; color:#94a3b8; }

.modal-bg{ position:fixed; inset:0; background:rgba(0,0,0,.55); display:flex; align-items:center; justify-content:center; z-index:1000; }
.modal{
  background:#0f172a;
  border-radius:12px;
  width:420px;
  padding:14px;
  display:grid;
  gap:8px;

  /* ✅ scroll */
  max-height: 88vh;
  overflow: auto;
}
.modal-title{ font-weight:700; margin-bottom:4px; }

.modal-actions{ display:flex; justify-content:flex-end; gap:8px; margin-top:8px; }
.modal-actions button{ background:#3b82f6; border:none; padding:8px 12px; border-radius:8px; color:white; font-weight:700; }

.pill{
  background:#111827;
  border:1px solid #1e293b;
  padding:6px 10px;
  border-radius:999px;
  color:#94a3b8;
  font-size:12px;
}
.pill b{ color:#e5e7eb; }


`;
